// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1HR5f","inputDescription":"styles_inputDescription__1l2pg"};